import { useState, useMemo } from 'react';

import { Popover } from 'antd';

import Colon from '@/components/Colon';

export default function MultiLineText({ label, text, title, line = 1 }) {
  const [open, setOpen] = useState(false);

  const useOriginalTitle = useMemo(() => {
    const htmlRegex = /<([a-z][^>\s]*)\b[^>]*>(.*?)<\/\1>|<[^>]+>/i;
    return !htmlRegex.test(title);
  }, [title]);

  const content = useMemo(() => {
    if (useOriginalTitle) {
      return;
    }
    return (
      <div
        className="max-w-[580px] break-all border-[1px] border-solid border-[#3c3c3c] bg-[#fff] p-[2px_8px] text-[12px] text-[#3c3c3c]"
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />
    );
  }, [title]);

  function openChange(value) {
    if (useOriginalTitle) {
      return;
    }
    setOpen(value);
  }

  return (
    <Popover
      placement="bottomLeft"
      overlayClassName="lcsc-popover-wrapper-hide-top-arrow"
      mouseEnterDelay={0.5}
      showArrow={false}
      content={content}
      onOpenChange={openChange}
      open={open}
      zIndex={2}
      align={{
        offset: [20, 8],
      }}
    >
      <p className={`leading-[18px] mr-[10px] text-[12px] line-clamp-${line} break-all`}>
        <span className="text-[#949FAB]">{label}</span>
        <Colon className="text-[#949FAB]" />
        <span
          className={`text-[#333333]`}
          title={useOriginalTitle ? title : ''}
          dangerouslySetInnerHTML={{
            __html: text,
          }}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        ></span>
      </p>
    </Popover>
  );
}
